<template>
    <div class="vertical-wrapper">
        <h1>Demo QR Code</h1> 
        <div style="flex: 0 0 30vh; width: 30vh; margin: 0 auto">
            <qrcode-stream  @decode="onDecode"></qrcode-stream>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { QrcodeStream,  } from 'vue-qrcode-reader'
export default {
    name: 'qr-code-access-view',
    components: {
        QrcodeStream,
      
    },
    sockets:{
        'set-qr-code-access-info-success': function(){
            this.$router.push({name: 'qr-code-access'});
            this.$swal({
                icon:'success',
                title:'success', 
                text:'Eintrag erfolgreich', 
            })
        }
    },
    methods:{
        onDecode(decodeString){
            const qrcode = decodeString.replace('https://myhbbox.com/login-via-url/', '')
            this.$store.commit('set-qrcode', qrcode);
            this.$socket.emit('get-qr-code-access-info', {token: this.token, qrcode: qrcode})
            this.$router.push({name: 'qr-code-access-info'})
        }
    },
    computed:{
        token(){
            return this.$store.getters.token
        }
    },
   
    data(){
        return{

        }
    }
}
</script>